// extracted by mini-css-extract-plugin
module.exports = {"Content":"Students_Content__1Xrdx"};